import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

interface mutateProps {
  communityId: string | number;
  fiscalYear: string | number;
}

const mutateCarryForward = async ({ communityId, fiscalYear }: mutateProps) => {
  return await axiosAuth.post(
    `${FISCAL_YEAR_API(communityId)}/${fiscalYear}/carry-forward`
  );
};

const useCarryForwardMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateCarryForward,
    ...queryParams,
  });

export default useCarryForwardMutation;
